import styled from 'styled-components';
import NumericInput from 'rc-input-number';

import 'rc-input-number/assets/index.css';

export default styled(NumericInput)`
  &.rc-input-number {
    max-width: 150px;
    font-size: 1em;
    height: 32px;
    overflow: hidden;
    position: relative;
  }
  .rc-input-number-handler {
    position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ddd;
    cursor: pointer;
    border-bottom: none !important;
    &:hover {
      background: #eee;
    }
    &-up {
      right: 0;
      left: auto;
    }
  }
  .rc-input-number-handler-wrap {
    width: 100%;
    overflow: visible;
    float: none;
    border: none;
    background: none;
    height: auto;
    top: 0;
  }
  &.rc-input-number-focused {
    box-shadow: 0 0 0 2px rgba(147, 167, 187, 0.3);
  }

  &:hover {
    border-color: #93a7bb;
    .rc-input-number-handler-up,
    .rc-input-number-handler-wrap {
      border-color: #93a7bb !important;
    }
  }
  .rc-input-number-input {
    font-weight: 700;
    color: #2e4964;
    &::-ms-clear {
      display: none !important;
    }
  }
  .rc-input-number-handler-down-inner:after {
    font-size: 23px;
    -webkit-font-smoothing: antialiased;
  }
  .rc-input-number-handler-down-inner:after,
  .rc-input-number-handler-up-inner:after {
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
  }
`;
